import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createBlock(_component_v_avatar, {
    size: _ctx.size,
    class: _normalizeClass(_ctx.avatar.classes)
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "user-avatar-initials",
        style: _normalizeStyle({fontSize: _ctx.initialsSize})
      }, _toDisplayString(_ctx.initials), 5),
      (_ctx.photo)
        ? (_openBlock(), _createBlock(_component_v_img, {
            key: 0,
            src: _ctx.photo,
            alt: "",
            cover: "",
            class: "user-avatar-photo"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["size", "class"]))
}